module.exports = __webpack_public_path__ + "media/src/img/payment/ApplePay3-5ca502487b3ef4b258755b1af8f6e810.svg";